import { TransportMessage, TransportMessageDetails } from './message-administration.model';
import { Identity } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';

@Injectable({
  providedIn: 'root'
})
export class MessageAdministrationService  {

  constructor(private httpService: HttpService) { }

  public getTransportMessages(): Observable<TransportMessage[]> {
    return this.httpService.postWithContext<TransportMessage[]>(environment.transportMessageAdminEndpoint, {});
  }

  public getTransportMessageDetails(identity: Identity): Observable<TransportMessageDetails> {
    return this.httpService.postWithContext<TransportMessageDetails>(environment.transportMessageAdminEndpoint + '/details', identity);
  }

  public saveTransportMessage(details: TransportMessageDetails): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.transportMessageAdminEndpoint + '/save', details);
  }

  public deleteTransportMessage(identity: Identity): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.transportMessageAdminEndpoint + '/delete', identity);
  }

  public sendTransportMessage(identity: Identity): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.transportMessageAdminEndpoint + '/send', identity);
  }
}
